export enum ActivityEventTypeEnum {
    PAGE_VIEWED = 'page_viewed',
    ELEMENT_CLICKED = 'element_clicked',
    LESSON_COMPLETED = 'lesson_completed',
    SEARCH = 'search',
    VIDEO_PAUSED = 'video_paused',
    VIDEO_PLAYED = 'video_played',
    VIDEO_SEEKED = 'video_seeked',
    VIDEO_PROGRESS = 'video_progress',
    VIDEO_COMPLETED = 'video_completed',
    MODULE_COMPLETED = 'module_completed',
    COURSE_COMPLETED = 'course_completed',
    LESSON_VIEWED = 'lesson_viewed',
    COMPONENT_VIEWED = 'component_viewed',
}

export enum VideoActivityResourceTypeEnum {
    VIDEO = 'video',
    TRAILER = 'trailer',
    SHORT = 'short',
    LIVE_EVENT = 'live_event',
}
